<template>
  <footer>
    <div class="tentaculos">
      <div class="tentaculo-1 tentaculo-flip">
        <div><div><div><div><div><div><div><div><div><div><div><div><div></div></div></div></div></div></div></div></div></div></div></div></div></div>
      </div>

      <div class="tentaculo-2 tentaculo-flip">
        <div><div><div><div><div><div><div><div><div><div><div><div><div></div></div></div></div></div></div></div></div></div></div></div></div></div>
      </div>

      <div class="tentaculo-3 tentaculo-flip">
        <div><div><div><div><div><div><div><div><div><div><div><div><div></div></div></div></div></div></div></div></div></div></div></div></div></div>
      </div>

      <div class="tentaculo-4 tentaculo-flip">
        <div><div><div><div><div><div><div><div><div><div><div><div><div></div></div></div></div></div></div></div></div></div></div></div></div></div>
      </div>

      <div class="tentaculo-5 tentaculo-flip">
        <div><div><div><div><div><div><div><div><div><div><div><div><div></div></div></div></div></div></div></div></div></div></div></div></div></div>
      </div>

      <div class="tentaculo-6">
        <div><div><div><div><div><div><div><div><div><div><div><div><div></div></div></div></div></div></div></div></div></div></div></div></div></div>
      </div>

      <div class="tentaculo-7">
        <div><div><div><div><div><div><div><div><div><div><div><div><div></div></div></div></div></div></div></div></div></div></div></div></div></div>
      </div>

      <div class="tentaculo-8">
        <div><div><div><div><div><div><div><div><div><div><div><div><div></div></div></div></div></div></div></div></div></div></div></div></div></div>
      </div>

      <div class="tentaculo-9">
        <div><div><div><div><div><div><div><div><div><div><div><div><div></div></div></div></div></div></div></div></div></div></div></div></div></div>
      </div>

      <div class="tentaculo-10">
        <div><div><div><div><div><div><div><div><div><div><div><div><div>
          <a href="./dd642a95aca86486d1cddfcbfdb7013e/56556bf5009dc98cb246c0b25f45a07c.html" class="rhyco"></a>
        </div></div></div></div></div></div></div></div></div></div></div></div></div>
      </div>
    </div>

    <div class="cabeca-lula"></div>
  </footer>

</template>

<script>
  export default {
    name: 'Footer',
  }
</script>

<style scoped lang="scss">
  /* Sizes */
  $baseWidth: 1150px;

  /* Variables */
  $red: #990000;
  $tentcolor: #430c00;
  $suctioncolor: #851508;

  /* Placeholders */
  %ease-infinite {
    animation-timing-function: ease;
    animation-iteration-count: infinite;
  }
  %linear-infinite {
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }

  footer, .footer {
    width: 100%;
    height: 600px;

    overflow: hidden;

    background: url('./../images/footer/footer.png') repeat-y;
    background-position: top center;

    position: relative;
  }

  .cabeca-lula {
    width: 260px;
    height: 430px;

    overflow: hidden;

    background: url('./../images/footer/squid-head.png') no-repeat;
    background-position: top center;

    position: absolute;

    animation-name: anm-cabeca-lula;
    animation-duration: 60s;
    animation-timing-function: ease;
    animation-iteration-count: infinite;
  }

  @keyframes anm-cabeca-lula {
    0%   {bottom: -500px; left: calc(50% - 130px); transform: rotate(0deg);}
    20%  {bottom: -100px; left: calc(40% - 130px); transform: rotate(-10deg);}
    50%  {bottom: -20px; left: calc(60% - 130px); transform: rotate(10deg);}
    80%  {bottom: -50px; left: calc(30% - 130px); transform: rotate(-5deg);}
    90%  {bottom: -200px; left: calc(40% - 130px); transform: rotate(15deg);}
    100% {bottom: -500px; left: calc(50% - 130px); transform: rotate(0deg);}
  }

  .tentaculos {
    width: 100%;

    height: 600px;

    font-size: 100px;
    overflow: hidden;

    position: relative;

    .tentaculo {
      &-1, &-2, &-3, &-4, &-5, &-6, &-7, &-8, &-9, &-10 {
        margin-left: -2em;
        position: absolute;
        z-index: 200;

        div {
          background: $tentcolor;
          font-size: 0.9em;
          height: 3em;
          width: 1em;
          border-radius: 100% 100%;
          box-shadow: 0.1em -0.8em 0 mix($tentcolor, white, 100%) inset, 0 0 0  0.3em mix($tentcolor, black, 98%) inset;
          position: absolute;
          top: 25%;
          left: 50%;

          &:before {
            content: '';
            background: $suctioncolor;
            position: absolute;
            z-index: 2;
            box-shadow:
            -0.1em 0.1em 0 mix($suctioncolor, black, 80%) inset, 0 0 0  0.1em mix($suctioncolor, black, 85%) inset;
            top: 50%;
            right: 100%;
            height: 0.7em;
            width: 0.3em;
            margin: -0.35em -0.15em;
            border-radius: 100%;
          }

          div {
            bottom: 1em;
            right: 0;
            top: auto;
            left: auto;
            transform: rotate(5deg);
            transform-origin: 100% 100%;

            $sel: '';
            @for $i from 0 to 20 {
              $sel: unquote($sel + ' div');
              #{$sel} { animation-delay: $i* -0.2s !important; }
            }
          }
        }
      }

      &-1 {
        bottom: -100px;
        left: 30%;

        div {
          animation: tentaculo-rot-1 7s ease-in-out alternate infinite;
        }
      }
      &-2 {
        bottom: 100px;
        left: 35%;

        div {
          animation: tentaculo-rot-2 15s ease-in-out alternate infinite;
        }
      }
      &-3 {
        bottom: 120px;
        left: 40%;

        div {
          animation: tentaculo-rot-3 13s ease-in-out alternate infinite;
        }
      }
      &-4 {
        bottom: -100px;
        left: 45%;

        div {
          animation: tentaculo-rot-4 8s ease-in-out alternate infinite;
        }
      }
      &-5 {
        bottom: 50px;
        left: 50%;

        div {
          animation: tentaculo-rot-5 17s ease-in-out alternate infinite;
        }
      }
      &-6 {
        bottom: 50px;
        left: 60%;

        div {
          animation: tentaculo-rot-6 6s ease-in-out alternate infinite;
        }
      }
      &-7 {
        bottom: -100px;
        left: 65%;

        div {
          animation: tentaculo-rot-7 11s ease-in-out alternate infinite;
        }
      }
      &-8 {
        bottom: 0px;
        left: 70%;

        div {
          animation: tentaculo-rot-8 14s ease-in-out alternate infinite;
        }
      }
      &-9 {
        bottom: -50px;
        left: 75%;

        div {
          animation: tentaculo-rot-9 20s ease-in-out alternate infinite;
        }
      }
      &-10 {
        bottom: 100px;
        left: 80%;

        div {
          animation: tentaculo-rot-10 23s ease-in-out alternate infinite;
        }

        @keyframes tentaculo-rot-1 { 0% { transform: rotate(-5deg); } 25% { transform: rotate(5deg); } 50% { transform: rotate(-5deg); } 75% { transform: rotate(5deg); } 100% { transform: rotate(-5deg); } }
        @keyframes tentaculo-rot-2 { 0% { transform: rotate(-8deg); } 25% { transform: rotate(8deg); } 50% { transform: rotate(4deg); } 75% { transform: rotate(-8deg); } 100% { transform: rotate(8deg); } }
        @keyframes tentaculo-rot-3 { 0% { transform: rotate(3deg); } 25% { transform: rotate(-3deg); } 50% { transform: rotate(1deg); } 75% { transform: rotate(3deg); } 100% { transform: rotate(-3deg); } }
        @keyframes tentaculo-rot-4 { 0% { transform: rotate(8deg); } 25% { transform: rotate(-8deg); } 50% { transform: rotate(4deg); } 75% { transform: rotate(8deg); } 100% { transform: rotate(-8deg); } }
        @keyframes tentaculo-rot-5 { 0% { transform: rotate(13deg); } 25% { transform: rotate(-13deg); } 50% { transform: rotate(7deg); } 75% { transform: rotate(13deg); } 100% { transform: rotate(-13deg); } }
        @keyframes tentaculo-rot-6 { 0% { transform: rotate(-3deg); } 25% { transform: rotate(3deg); } 50% { transform: rotate(-1deg); } 75% { transform: rotate(-3deg); } 100% { transform: rotate(3deg); } }
        @keyframes tentaculo-rot-7 { 0% { transform: rotate(5deg); } 25% { transform: rotate(-5deg); } 50% { transform: rotate(2deg); } 75% { transform: rotate(5deg); } 100% { transform: rotate(-5deg); } }
        @keyframes tentaculo-rot-8 { 0% { transform: rotate(-13deg); } 25% { transform: rotate(13deg); } 50% { transform: rotate(-7deg); } 75% { transform: rotate(-13deg); } 100% { transform: rotate(13deg); } }
        @keyframes tentaculo-rot-9 { 0% { transform: rotate(3deg); } 25% { transform: rotate(-5deg); } 50% { transform: rotate(3deg); } 75% { transform: rotate(5deg); } 100% { transform: rotate(-3deg); } }
        @keyframes tentaculo-rot-10 { 0% { transform: rotate(13deg); } 25% { transform: rotate(-13deg); } 50% { transform: rotate(7deg); } 75% { transform: rotate(13deg); } 100% { transform: rotate(-13deg); } }
      }

      &-flip {
        -webkit-transform: scaleX(-1);
        -moz-transform: scaleX(-1);
        -o-transform: scaleX(-1);
        transform: scaleX(-1);
        -ms-filter: "FlipH";
        filter: FlipH;
      }
    }
  }
  .rhyco {
    background: url('./../images/footer/rhyco-saveme.png') no-repeat;
    background-position: top center;
    cursor: pointer;
    display: block;
    width: 97px;
    height: 150px;
    z-index: 10;
    transform: scaleY(-1) translate(-40px, 110px) rotate(45deg);
    -webkit-transform: scaleY(-1) translate(-40px, 110px) rotate(45deg);;
    -moz-transform: scaleY(-1) translate(-40px, 110px) rotate(45deg);;
    -o-transform: scaleY(-1) translate(-40px, 110px) rotate(45deg);;
    -ms-filter: "FlipW";
    filter: FlipW;
  }
</style>
